import 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Rx';
import { Http } from '@angular/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import {ApiService} from './api.service';

@Injectable()
export class FormsService {

  apiService: ApiService = new ApiService(this.http);

  static baseURL = environment.formsLink;
  constructor(private http: Http) { }

  getForms(orgId: string, role: string){
    // return this.apiService.getCall('formsLink', `organizations/${orgId}/roles/${role.toLowerCase()}`);
    return this.apiService.getCall('formsLink', `roles/${role.toLowerCase()}`);
  }

  getAllForms(stateName: string){
    return this.apiService.getCall('formsLink', `forms/description/${stateName}`);
  }

}



// WEBPACK FOOTER //
// ./src/app/main/shared/services/forms.service.ts